export default "__VITE_ASSET__BSUiHIyL__"